import { Link } from "react-router-dom";
import { listTickets } from "../lib/api";
import { useApi } from "../lib/useApi";
import { EmptyState, ErrorState, Loading } from "../components/States";
import { StatusBadge } from "../components/Badge";
import { formatRelative } from "../lib/format";

/** The signed-in contact's own requests (GET /tickets). */
export function TicketsPage() {
  const { data, loading, error, reload } = useApi((signal) => listTickets(signal), []);
  const tickets = data?.tickets ?? [];

  return (
    <div className="tickets">
      <div className="page-head">
        <div>
          <h1>My requests</h1>
          <p className="sub">Track the status of requests you’ve submitted.</p>
        </div>
        <Link to="/tickets/new" className="btn primary">
          Submit a request
        </Link>
      </div>

      {loading ? (
        <Loading label="Loading your requests…" />
      ) : error ? (
        <ErrorState error={error} onRetry={reload} />
      ) : tickets.length === 0 ? (
        <EmptyState title="No requests yet">
          <p className="muted">When you submit a request, it’ll show up here.</p>
          <Link to="/tickets/new" className="btn small">
            Submit your first request
          </Link>
        </EmptyState>
      ) : (
        <ul className="ticket-list" role="list">
          {tickets.map((t) => (
            <li key={t.id}>
              <Link to={`/tickets/${encodeURIComponent(t.id)}`} className="ticket-row">
                <div className="ticket-row-main">
                  <span className="ticket-subject">{t.subject}</span>
                  <span className="ticket-meta muted">
                    #{t.number} · Updated {formatRelative(t.updated_at)}
                  </span>
                </div>
                <StatusBadge statusId={t.status_id} />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
